export const FIAT_WIDGET_HEALTH_ENDPOINTS: {
  [providerName: string]: string;
} = {
  blockchain: 'https://www.blockchain.com/pay/widget/healthz',
};
